/**
 * @file Helper functions for useComposeActions
 */

import { ComposeNodeType } from '../../../containers/compose/props';
import translate from '../../../i18n/translate';
import { ComposeTypeParam } from '../../../models/pageParams';

/**
 * Get which label to use for the compose action
 *
 * @param composeType The type of object compose is for (post or task)
 * @param nodeType    Whether the action is being used for creating messages or templates
 *
 * @returns           The translation key for label
 */
export const getComposeActionLabel = (
  composeType: ComposeTypeParam | null,
  nodeType: ComposeNodeType,
): string => {
  const isPost = composeType === 'post';

  if (nodeType === 'MESSAGE') {
    return translate(isPost ? 'COMPOSE__TITLE' : 'TASK__CREATE');
  }

  return translate(isPost ? 'POST_TEMPLATE__CREATE' : 'TASK_TEMPLATE__CREATE');
};
